var SupportedLocales = {
    EN_AU: 'en-AU',
    EN_CA: 'en-CA',
    EN_GB: 'en-GB',
    EN_US: 'en-US',
    EN_NZ: 'en-NZ',
    FR_CA: 'fr-CA',
    FR_FR: 'fr-FR',
    ES_ES: 'es-ES',
    IT_IT: 'it-IT',
};

export { SupportedLocales };
